import React, { Component } from "react";
import { InputNumber } from "antd";

class FormList extends Component {
  handleBoardNumChange = boardNum => {
    this.triggerChange({ boardNum });
  };

  handleNoBoardNumChange = noBoardNum => {
    this.triggerChange({ noBoardNum });
  };

  triggerChange = changedValue => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue
      });
    }
  };

  render() {
    const { value } = this.props;
    const { boardNum, noBoardNum } = value;
    const boardNumProps = {
      keyName: "boardNum",
      value: boardNum,
      onChange: this.handleBoardNumChange,
      max: 20,
      precision:0,
      min: 0
    };
    const noBoardNumProps = {
      keyName: "noBoardNum",
      value: noBoardNum,
      onChange: this.handleNoBoardNumChange,
      max: 20,
      precision:0,
      min: 0
    };
    return (
      <div>
        <>
          <div>
            寄宿制学校每日巡查&nbsp;
            <InputNumber {...boardNumProps} /> &nbsp;次
          </div>
          <div style={{marginTop:10}}>
            非寄宿制学校每日巡查&nbsp;
            <InputNumber {...noBoardNumProps} /> &nbsp;次
          </div>
        </>
      </div>
    );
  }
}

export default FormList;
